/* eslint-disable fp/no-let */
import translate from '~/zf/frontend/common/localization/translate';

/*
  [Vue migration] Developer Note
  This component has a twin version for both Vue 2 and Vue 3 projects.
  When making changes, remember to update and test both versions.
*/
export default function ChartPortletHead() {
  let options;
  let containerSelector;

  function createPickerElement(id, displayDateTime) {
    return $('<div/>', {
      id,
      class: 'clickable chart-datepicker hasDatepicker',
    }).append(displayDateTime)
      .append($('<span/>', { class: 'icon-calendar-custom right' }));
  }

  function createNavigationControl(type) {
    const btnImages = {
      prev: 'icon-arrow-left2',
      next: 'icon-arrow-right2',
    };
    return $('<button />').addClass(`btn btn-secondary btn-sm chart-${type} icomoon ${btnImages[type]}`)
      .attr('type', 'button');
  }

  return {
    appendTo(head, containerId, isSchemaChart = false) {
      const pickerId = `chart-datepicker-${containerId}`;
      containerSelector = `#${containerId}`;
      options = {
        prevNextControls: [createNavigationControl('prev'), createNavigationControl('next')],
        displayDatetime: $('<span/>').addClass('chartDisplayTime'),
        displayTitle: $('<span/>', { text: head.text() }).addClass('chartDisplayTitle'),
        displaySubtitle: $('<span/>', { text: '' }).addClass('chartDisplaySubtitle'),
        datepicker: {
          parentEl: `#${pickerId}`,
          singleDatePicker: true,
          showDropdowns: false,
          opens: 'center',
        },
      };
      if (isSchemaChart) {
        options.displayTitle = $('<span/>', { text: `${translate('portlet.SYSTEM_PLAN_CHART')}` }).addClass('chartDisplayTitle');
      }
      head.text('').append($('<div/>', { class: 'w-40 float-left' }).append(options.displayTitle).append(options.displaySubtitle));
      $('<span/>', { class: 'datepicker-widget chartDateSelector portlet-head' })
        .append(options.prevNextControls[0].attr('title', `${translate('javascript.TX_PREV')} (p)`)
          .attr('name', 'datepicker-prev-button'))
        .append(createPickerElement(pickerId, options.displayDatetime))
        .append(options.prevNextControls[1].attr('title', `${translate('javascript.TX_NEXT')} (n)`)
          .attr('name', 'datepicker-next-button'))
        .appendTo(head);
    },
    getChartOptions() {
      return options;
    },

    activateDatePicker() {
      $(containerSelector).chart('enablePrevNextControls');
      const picker = $(containerSelector).data('chart').opts.pickerExtended.getDatepicker();
      picker.readOnly = false;
    },

    deactivateDatePicker() {
      $(containerSelector).chart('disablePrevNextControls');
      const picker = $(containerSelector).data('chart').opts.pickerExtended.getDatepicker();
      picker.readOnly = true;
    },
  };
}
